import { render, staticRenderFns } from "./ManageTagsModal.vue?vue&type=template&id=a2ae7324&scoped=true"
import script from "./ManageTagsModal.vue?vue&type=script&lang=js"
export * from "./ManageTagsModal.vue?vue&type=script&lang=js"
import style0 from "./ManageTagsModal.vue?vue&type=style&index=0&id=a2ae7324&prod&scoped=true&lang=css"
import style1 from "./ManageTagsModal.vue?vue&type=style&index=1&id=a2ae7324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ae7324",
  null
  
)

export default component.exports